import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Button } from 'Components';
import './AccordionHeader.css';

class AccordionHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ open: this.props.open });
    }
  }

  handleClick() {
    if (this.props.handleClick) {
      return this.props.handleClick();
    }
    return this.setState(({ open }) => ({ open: !open }));
  }

  render() {
    const { title, subtitle } = this.props;
      const toggleText = this.state.open ? i18n.t('common:Close') : i18n.t('common:View');

    return (
      <div className={`accordion-header ${this.state.open ? 'accordion-header--open' : ''}`}>
        <Button onClick={this.handleClick} className="accordion-header__nav">
          { title && <div className="accordion-header__nav__title">{title}</div>}
          <div className="accordion-header__nav__arrow">
            <i className="material-icons">{ this.state.open ? 'arrow_drop_up' : 'arrow_drop_down' }</i>
            <span>{ toggleText }</span>
          </div>
        </Button>
        <div className="accordion-header__content">
          {
            this.state.open && this.props.children
          }
        </div>
      </div>
    );
  }
}

AccordionHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node,
  handleClick: PropTypes.func,
};

AccordionHeader.defaultProps = {
  open: false,
  subtitle: i18n.t('common:View'),
};

export default AccordionHeader;



// WEBPACK FOOTER //
// ./src/components/AccordionHeader/AccordionHeader.jsx